import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HeaderTitle } from '../../../../../../common/HeaderTitle.jsx';
import GanttChart from '../../../../../../common/gantt/GanttChart.jsx';
import { usePlanHarmData } from '../../../../../../../api/domain/elementyRejstru/queries/usePlanHarmData.jsx';
import Loader from "../../../../../../common/Loader.jsx";


export const ViewSprawozdanieGantt = () => {
    const rola = useSelector((state) => state.user.role)
    const { rejestrId, planHarmId } = useParams();

    const {
        data: responseData,
        isLoading,
        isError
    } = usePlanHarmData(rejestrId, planHarmId);

    const planHarmForm = responseData || null;

    if (isLoading) {
        return <Loader/>;
    }

    if (isError || !planHarmForm) {
        return (
            <HeaderTitle
                title={`Nie można załadować Planowanego Harmonogramu dla projektu ID: ${rejestrId}.`}
                destination={`/${rola}/rejestr/lista`}
            />
        );
    }

    return (
        <div className="container-fluid py-4">
            <HeaderTitle
                size={'fs-2'}
                breadcrumbLinks={[
                    { label: 'Wszystkie projekty', to: `/${rola}/rejestr/lista` },
                    { label: 'Wykres Planu Harmonogramu' },
                ]}
                data={[['ID Projektu', rejestrId]]}
                title={'Wykres Planowanego Harmonogramu'}
            />


            <GanttChart
                projects={[
                    {
                        tasks: planHarmForm.inicjacja_zadania_list || [],
                        projectId: 'inicjacja',
                        projectName: 'Etap inicjacji',
                    },
                    {
                        tasks: planHarmForm.przygotowania_zadania_list || [],
                        projectId: 'przygotowania',
                        projectName: 'Etap przygotowania',
                    },
                    {
                        tasks: planHarmForm.realizacja_zadania_list || [],
                        projectId: 'realizacja',
                        projectName: 'Etap realizacji',
                    },
                    {
                        tasks: planHarmForm.zamykania_zadania_list || [],
                        projectId: 'zamykania',
                        projectName: 'Etap zamykania',
                    },
                ]}
            />

        </div>
    )
}

export default ViewSprawozdanieGantt